// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"469":"a4cd5493","679":"758c763e"}[chunkId] + ".chunk.css";
};